// Constants
export const info_ventas = () => {
  return {
    info_ventas: {
      id: {
        description: 'id autoincrement',
        label: 'Id',
        name: 'pacId',
        readonly: true,
        type: 'number',
        dataform: ['orden_registro','orden_antiguos'],
        datatype: {
          predeterminate: ''
        }
      },
      id_datos_pacientes: {
        type: 'text',
        label: 'Paciente',
        dataform: ['orden_registro','orden_antiguos'],
        placeholder: '',
        description: 'paciente',
        validate: '',
        datatype: 
        {
          predeterminate: '',
        }
      },
      id_info_orden: {
        type: 'text',
        label: 'info examen',
        dataform: ['orden_registro','orden_antiguos'],
        placeholder: '',
        description: 'paciente',
        validate: '',
        datatype: 
        {
          predeterminate: '',
        }
      },
      fecha: {
        type: 'text',
        label: 'Fecha',
        dataform: ['orden_registro','orden_antiguos'],
        placeholder: '',
        description: 'fecha',
        validate: '',
        datatype: 
        {
          type: 'date',
          disabled: false,
          predeterminate: '',
        }
      },
      consecutivo: {
        type: 'number',
        label: 'Registro orden',
        dataform: ['orden_registro','orden_antiguos'],
        placeholder: '',
        description: 'numero_factura',
        validate: '',
        datatype: 
        {
          type: 'price',
          disabled: false,
          predeterminate: '',
          prepend: '',
          append: '',
        }
      },
      total: {
        type: 'number',
        label: 'total',
        dataform: ['orden_registro','orden_antiguos','orden_pendientes'],
        placeholder: '',
        description: 'total',
        validate: '',
        datatype: 
        {
          type: 'price',
          disabled: false,
          predeterminate: '0',
          prepend: '$',
          append: '',
        }
      },
      abono: {
        type: 'number',
        label: 'Abona',
        dataform: ['orden_registro','orden_antiguos','orden_pendientes'],
        placeholder: '',
        description: 'abona',
        validate: '',
        datatype: 
        {
          type: 'price',
          disabled: false,
          predeterminate: '0',
          prepend: '$',
          append: '',
        }
      },
      saldo: {
        type: 'number',
        label: 'Saldo',
        dataform: ['orden_registro','orden_antiguos','orden_pendientes'],
        placeholder: '',
        description: 'resta',
        validate: '',
        datatype: 
        {
          type: 'price',
          disabled: true,
          predeterminate: '0',
          prepend: '$',
          append: '',
        }
      },
    }
  }
}

export function asign_info_ventas(){
  var asign= Object.keys(info_ventas().info_ventas);
  var objeto = info_ventas().info_ventas
  var nuevoArray = {}
  for(var i=0; i<asign.length; i++)
  {
          var createdataform= objeto[asign[i]].dataform
          for(var j=0; j<createdataform.length;  j++)
          {
                  nuevoArray[createdataform[j]] = {}
          }
  }        
  return nuevoArray
}

